<div class="sidenav-content">
    <div class="bcontainer2">
        <div class="main-content"> 


    <div class="spacer2"></div>

    <div class="containter">
        <a href="#" style="color: #333; text-decoration: none; outline: none;" *ngIf="!blck"><img src="assets/images/closeIcon.svg" matTooltip="Close" class="close-icon"></a>
      <div class="mfhd">
        <i
          class="fa fa-angle-left"
          aria-hidden="true"
          style="padding-right: 5px"
        ></i
        >Terms of Use

      </div>

    <p>
        Welcome to <b>XDBrain (XDB)</b>. These <b>Terms of Use</b> ("Terms") govern your access to and use of our services. By signing up for or using our services, you agree to these Terms. Please read them carefully.
    </p>

    <ol>
        <li class="dhd">Acceptance of Terms</li>
        <ol type="a">
            <li>
            By creating an account or using the <b>XDB</b> pattern based storage system service, you confirm that you are authorized to enter into these Terms on behalf of yourself. If you do not agree to these Terms, you must not use our services.
            </li>       
        </ol>
        
        <div class="spacer2"></div>

        <li class="dhd">Description of Services</li>
        <ol type="a">
        <li>
        <b>XDB</b> is a pattern based, AI-powered storage platform that enables users to build personal and institutional memory. Through <b>XDB</b>, users may be able to:
            <ol type="i">
                <li>Index the information into a memory system using tokens and patterns;</li>
                <li>Retrieve relevant memories using either keyword, token, or semantic similarity</li>
            </ol>
        </li>
        <div class="spacer"></div>
        <li>
            <b>XDB</b> is continuously evolving and may introduce, modify, or remove features over time to improve the user experience or respond to market, technical, or regulatory developments.
        </li>
        </ol>

        <div class="spacer2"></div>

        <li class="dhd">Third Party Services</li>
        <ol type="a">
        <li>
            The Services may contain links to third-party services (“Third Party Services”).  In addition to this Agreement, you may be bound by any additional terms required by your third-party service providers in their provision of such Third Party Services. Please be aware that this Agreement does not govern third parties’ relationships with you. These third parties are responsible for any product or service warranties, whether express or implied by law, provided to you.  We make no warranties or representations, express or implied, about such linked Third Party Services, the third parties they are owned and operated by, the information contained on them or the suitability of their products or services. You acknowledge sole responsibility for and assume all risk arising from your use of any third-party websites, applications, or resources. <b>XDB</b> is not responsible for the products, service warranties or services of third-parties.
        </li>
        <div class="spacer"></div>
        <li>
            We provide access to Third Party Services only as a convenience, do not have control over their content, do not warrant or endorse, and are not responsible for the availability or legitimacy of, the content, products or services on or accessible from those Third Party Services (including any related websites, resources or links displayed therein). We make no warranties or representations, express or implied, about such linked Third Party Services, the third parties they are owned and operated by, the information contained on them or the suitability of their products or services. You acknowledge sole responsibility for and assume all risk arising from your use of any third-party websites, applications, or resources.
        </li>
        <div class="spacer"></div>
        <li>
            You accept that we and our affiliates may be required to share your user information in connection with these Third Party Services, or as required under applicable laws or demanded upon a lawful request by any government. For more information on such information sharing, please consult the Privacy Policy.
        </li>
        </ol>

        <div class="spacer2"></div>

        <li class="dhd">User Responsibilities</li>
        <ol type="a">
        <li>
            Account Security
            <ol type="i">
                <li>You are responsible for maintaining the confidentiality of your account credentials, including, but not limited to username and passwords</li>                
            </ol>
        </li>
        <div class="spacer"></div>
        <li>
            Prohibited Uses
            <ol type="i">
                <li>Do not use the services for activities that are illegal.</li>
                <li>Do not use the service for malware, spam, or malicious activities.</li>
                <li>Do not reverse engineer or exploit the service for unauthorized commercial use.</li>
            </ol>
        </li>
        <div class="spacer"></div>
        <li>
            Compliance with Laws
            <ol type="i">
                <li>You must ensure compliance with all applicable laws, including data privacy and intellectual property laws.</li>                
            </ol>
        </li>
        </ol>


        <div class="spacer2"></div>

        <li class="dhd">Data Privacy</li>
        <ol type="a">
        <li>
            Secure Storage
            <ol type="i">
                <li>Information uploaded to <b>XDB</b> is stored securely and is accessible only by authorized users.</li>
            </ol>
        </li>
        <div class="spacer"></div>
        <li>
            Deletion of Data
            <ol type="i">
                <li>Upon termination of your account, all account information will be permanently deleted after <b>30 days</b>.</li>                
            </ol>
        </li>
        <div class="spacer"></div>
        <li>
            Security
            <ol type="i">
                <li>Our systems are compliant with SOC 2 Type II, covering security, availability, and confidentiality of our information.</li>                
            </ol>
        </li>
        </ol>
        
        
        <div class="spacer2"></div>

        <li class="dhd">Termination of Services</li>
        <ol type="a">
        <li>
            By You
            <ol type="i">
                <li>You may cancel your account at any time by contacting <b>XDB</b>. Services will terminate upon your termination request.</li>
            </ol>
        </li>
        <div class="spacer"></div>
        <li>
            By <b>XDB</b>
            <ol type="i">
                <li>We reserve the right to suspend or terminate your account if you violate these Terms.</li>                
            </ol>
        </li>
        </ol>
        
        
        <div class="spacer2"></div>

        <li class="dhd">Limitation of Liability</li>
        <ol type="a">
        <li>
           <b>XDB</b> is provided on an “AS IS” basis. We do not guarantee accuracy, reliability, or timeliness of document insights.
        </li>
        </ol>
        
        <div class="spacer2"></div>

        <li class="dhd">Intellectual Property</li>
        <ol type="a">
        <li>
           All content, software, and technology provided by <b>XDB</b> are its exclusive property.
        </li>
        </ol>  
        
        <div class="spacer2"></div>

        <li class="dhd">Changes to Terms</li>
        <ol type="a">
        <li>
           <b>XDB</b> reserves the right to modify these Terms. Continued use after updates indicates acceptance.
        </li>
        </ol>         

        <div class="spacer2"></div>

        <li class="dhd">Governing Law and Jurisdiction</li>
        <ol type="a">
        <li>
           Any disputes will be subject to the jurisdiction of the state and federal courts serving Douglas County, Kansas. All disputes will be resolved based on the laws of the state of Kansas.
        </li>
        </ol>  
        
        <div class="spacer2"></div>

        <li class="dhd">Contact Us</li>
        <ol type="a">
        <li>
           If you have questions, contact us at:
            <ol type="i">
                <li><b>XDB Support<br>
                    Email: <a href="mailto:support@netxd.com" class="routeClr">{{'support@netxd.com'}}</a></b>
                </li>                
            </ol>
        </li>
        </ol>  
        
       <div class="spacer2"></div>

        <li class="dhd">Acknowledgment</li>
        <ol type="a">
        <li>
           By using <b>XDB</b>, you acknowledge that you have read, understood, and agree to these Terms of Use.
        </li>
        </ol>          
        

    </ol>

     <div class="spacer5"></div>
    <hr>
    <div class="spacer5"></div>

    <h1 style="text-align: left;">NetXD E-Sign Disclosure</h1>

        <div class="spacer2"></div>

    <ol>
        <li class="dhd">Scope</li>
        <ol type="a">
            <li>
            This disclosure (“Disclosure”) applies to all notices, disclosures, statements, and other communications that <b>XDB</b>, a product of NetXD, Inc. or its affiliates ("NetXD") provide to you regarding NetXD products and services (“Services”). It also applies to agreements governing your use of the Services, and communications under them. All these communications and agreements are collectively referred to as “Communications."
            </li>
            <div class="spacer"></div>
            <li>
            By opening an account or applying to use the Services, you agree to this Disclosure and confirm your consent to (a) receive Communications electronically; and (b) the use of electronic signatures. If you choose not to consent to this Disclosure or if you withdraw your consent, you may be unable to use the Services.
            </li>                   
        </ol>
        
        <div class="spacer2"></div>

        <li class="dhd">Covered Communications</li>
        <ol type="a">
        <li>
        Examples of Communications include:
            <ol type="i">
                <li>Any disclosure statement governing your use of the Services, including Terms and Conditions, as updated from time to time;</li>
                <li>Any disclosure required by Law, including Privacy Policy, as updated from time to time;</li>
                <li>Billing statements or invoices, receipts and account history;</li>
                <li>Letters, notices and alerts regarding the Services and any changes to the Services; and</li>
                <li>Other disclosures, notices and communications in connection with (a) your application for the Services; (b) your NetXD accounts or Services; or (c) account maintenance or servicing.</li>
            </ol>
        </li>
        <div class="spacer"></div>
        <li>
            This Disclosure applies to all Communications that NetXD provides to you on its behalf or on behalf of its service providers or their affiliates.
        </li>
        </ol>

        <div class="spacer2"></div>

        <li class="dhd">Methods of Providing Communications</li>
        <ol type="a">
        <li>
            Unless Law otherwise requires, or NetXD otherwise agrees, NetXD may provide Communications to you by (a) posting them on the NetXD Website; (b) notifying you through the Services or in your account; (c) sending a text message to the mobile phone number listed in the applicable account; (d) sending an email to the email address listed in the applicable account; or (e) delivering them in another electronic format. Charges may apply to Communications sent by text or other electronic means and message frequency varies. Carriers are not liable for any delayed or undelivered messages. Messages and data rates may apply.
        </li>
        </ol>

        <div class="spacer2"></div>

        <li class="dhd">Electronic Signatures</li>
        <ol type="a">
        <li>
           NetXD may execute Communications electronically. If NetXD requests, you will execute Communications electronically. You also agree that Communications you or NetXD sign electronically will have the same legal effect as a signed physical document.
        </li>
        </ol>

        <div class="spacer2"></div>

        <li class="dhd">Hardware and Software Requirements</li>
        <ol type="a">
        <li>
           In order to access, view, sign and retain electronic Communications that NetXD provides to you, you must have:
           <ol type="i">
                <li>An up-to-date device (e.g., computer, tablet, or mobile phone) which has internet access;</li>
                <li>A current, compatible web browser, including the current or immediately preceding version of Chrome, Internet Explorer, Firefox, Safari and Edge;</li>
                <li>A valid email account;</li>
                <li>A cellular phone capable of receiving text or SMS messages, as applicable;</li>
                <li>An operating system on your device capable of receiving, accessing and displaying Communications in electronic form via text-formatted email or gaining access to the NetXD Website using a supported browser, including any necessary software (e.g., Adobe to read PDF documents); and</li>
                <li>If you wish to store or print any Communications, a device capable of storing and printing Communications.</li>
                <li>If you use a spam filter that blocks or re-routes emails from senders not listed in your email address book, you must add relevant NetXD email accounts and addresses to your email address book.</li>
            </ol>
        </li>
        </ol>
        
        
        <div class="spacer2"></div>

        <li class="dhd">Accessibility</li>
        <ol type="a">
        <li>
           If you are having problems viewing or accessing any Communications, please contact us with the information included in your account or on the NetXD website.
        </li>
        </ol>
                
        <div class="spacer2"></div>

        <li class="dhd">Withdrawal of Consent</li>
        <ol type="a">
        <li>
           Where offered, you may disable electronic Communications in your NetXD account by responding to the Communication with “STOP”, or by following instructions in the Communication. NetXD will confirm when you have successfully unsubscribed. You may also request assistance by contacting us at <a href="mailto:support@netxd.com" class="routeClr">{{'support@netxd.com'}}</a>.
        </li>
        <div class="spacer"></div>
        <li>In addition, you may withdraw your consent to receive electronic Communications, or to electronic signatures, under this Disclosure by writing to NetXD at <a href="mailto:support@netxd.com" class="routeClr">{{'support@netxd.com'}}</a> or by contacting NetXD via support. Your withdrawal of consent to receive electronic Communications will be effective after NetXD has had a reasonable period of time to process your withdrawal.</li>
        <div class="spacer"></div>
        <li>By disabling or withdrawing your consent to electronic Communications, you will no longer receive them from NetXD, but you may be disabling important security controls or features in your NetXD account, and your ability to use the Services may be adversely affected or terminated.</li>
        </ol>
        
        <div class="spacer2"></div>

        <li class="dhd">Requesting Paper Copies</li>
        <ol type="a">
        <li>
           You can request paper copies of electronic communications from NetXD by contacting NetXD at <a href="mailto:support@netxd.com" class="routeClr">{{'support@netxd.com'}}</a>. In your request, please specify the Communication you would like to receive in paper form, and your current mailing address.
        </li>
        </ol>  
        
        <div class="spacer2"></div>

        <li class="dhd">Updating Contact Information</li>
        <ol type="a">
        <li>
           It is your responsibility to keep your contact information, including your primary email address and phone number, current. You can update your primary email address and other contact information by logging into your NetXD account.
        </li>
        </ol>         

        <div class="spacer2"></div>

        <li class="dhd">U.S. Federal Law</li>
        <ol type="a">
        <li>
           If you are located in the United States, you acknowledge and agree that the Services are subject to the federal Electronic Signatures in Global and National Commerce Act ("E-SIGN Act"), and that you intend that the E-SIGN Act will apply to validate your ability to engage electronically in transactions related to the NetXD Services.
        </li>
        </ol>  
        

    </ol>    
<div class="spacer5"></div>

            </div>
            </div> 
        </div>
        
    </div>
